module.exports = __webpack_public_path__ + "static/flags/GK-a97409d061e9c86f7acd6c03de812395.gif";